import { useQuery } from "react-query"
import { AxiosError } from "axios"
import { hasValidFilters } from "components/Shared/utils/utils"
import {
	RequestParameters,
	CrossSellingRanking,
} from "components/Transactional/CrossSelling/interfaces"
import { getCrossSellingRankingInformation } from "components/Transactional/CrossSelling//service"

const SANKEY_QUERY_ID = "crossSellingRankingInformation"
const FIELDS_TO_VALIDATE: Array<keyof RequestParameters> = [
	"vendors",
	"departments",
	"startDate",
	"endDate",
]

const useGetRankingInformation = (filters: RequestParameters) => {
	const { isLoading, data, isError, error, refetch } = useQuery<
		CrossSellingRanking,
		AxiosError
	>(
		[SANKEY_QUERY_ID, filters],
		() => getCrossSellingRankingInformation(filters),
		{
			enabled: hasValidFilters(filters, FIELDS_TO_VALIDATE),
			retry: false,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
		}
	)

	return { isLoading, data, isError, error, refetch }
}

export default useGetRankingInformation
